/****************************************************
 * Configuration points for the application
 * Api_ items affect where the server gets called
 ****************************************************/

// window.__APP_CONFIG__ is set by /env.js, which the server writes from its
// CLIENT_* settings (see server/src/app.js), so one build serves every
// environment. Build-time VITE_* values and the page's own origin are fallbacks.
const runtime = (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};
const viteEnv = import.meta.env || {};

const fromEnv = (key, fallback) => runtime[key] ?? viteEnv['VITE_' + key] ?? fallback;

// The server hosts both the client and its /api, so same-origin is the default.
const here = typeof window !== 'undefined' ? window.location : null;
const originProtocol = here ? here.protocol.replace(':', '') : 'https';
const originHost = here ? here.hostname : 'localhost';
const originPort = here && here.port ? here.port : (originProtocol === 'http' ? '80' : '443');

export const API_PROTOCOL = fromEnv('API_PROTOCOL', originProtocol);
export const API_HOST = fromEnv('API_HOST', originHost);
export const API_PORT = fromEnv('API_PORT', originPort);
export const API_PATH = fromEnv('API_PATH', '');
export const FINISHED_LOCATION = fromEnv('FINISHED_LOCATION', '/');
// reCAPTCHA site key (public); from server/.env GOOGLE_SITE_KEY via /env.js
export const GOOGLE_SITE_KEY = fromEnv('GOOGLE_SITE_KEY', '6LdBw74UAAAAAKYwWWGYSMip0xR-38Ul8UIAGYyq');
// Optional banner shown under the header
export const NOTIFICATION = fromEnv('NOTIFICATION', null);
export const SHOW_ENV_HEADER = fromEnv('SHOW_ENV_HEADER', null);
